import React, { useState } from 'react';
import { Icon, Space, Button, Title, message } from '@bb/elements-web';
import { sendSingleAccessEmailInvite } from 'api/SupraController';
import styled from 'styled-components';
import {
  MarketingBadgeApple,
  MarketingBadgeGoogle,
} from 'components/MarketingBadges';
import { StyledCard, StyledText } from './styledComponents';
import { useSingleAccessSetupContext } from '../context/SingleAccessSetupContext';

export default function SingleAccessSuccessCard() {
  const { userData } = useSingleAccessSetupContext();

  const [isResending, setIsResending] = useState(false);

  const resendEmailInvite = async () => {
    if (!userData) return;

    setIsResending(true);

    try {
      await sendSingleAccessEmailInvite({
        granteeId: userData.id,
      });

      message.success('The email has been resent. Please check your inbox.');
    } catch (error) {
      message.error(
        'Failed to resend email. Please try again and contact support if the issue persists.',
      );
    } finally {
      setIsResending(false);
    }
  };

  return (
    <StyledCard $bordered={false} $noPadding>
      <Space size={24} direction="vertical">
        <IconWrapper>
          <Icon icon="checkOutlined" color="primary" size={24} />
        </IconWrapper>
        <Space size={8} direction="vertical" align="center">
          <Title
            dataCy="single-access-success-title"
            level={4}
            textAlign="center"
            margin={0}
          >
            Check your inbox!
          </Title>
          <StyledText size="large" $secondary $alignCenter>
            In the meantime, download the app and login with your email.
          </StyledText>
          <Space
            direction="horizontal"
            size={16}
            align="center"
            style={{ marginTop: '8px' }}
          >
            <MarketingBadgeApple />
            <MarketingBadgeGoogle />
          </Space>
        </Space>

        <Space size={8} direction="vertical" align="center">
          <StyledText size="large" $secondary $alignCenter>
            It may take a few minutes to send the email. Check your junk folder.
          </StyledText>

          <Button
            dataCy="single-access-resent-invitation-button"
            onClick={resendEmailInvite}
            disabled={isResending}
            loading={isResending}
          >
            Resend Invitation
          </Button>
        </Space>
      </Space>
    </StyledCard>
  );
}

const IconWrapper = styled.div`
  background-color: #f0f7ff;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
`;
